export default __webpack_public_path__ + "static/media/english-to-japanese-screenshot-03.b9287d43.png";